class Maps {
    constructor (element, options) {
        const settings = {
            breakpoints: null,
            coordinates: null,
            additionalCoordinates: null,
            geolocationUi: true,
            mapTypeControl: false,
            position: { lat: 52.37052, lng: 9.73322 },
            streetViewControl: false,
            styles: [
                {
                    featureType: 'administrative',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#8c9296'
                        }
                    ]
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#efebe3'
                        }
                    ]
                },
                {
                    featureType: 'landscape.man_made',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#e9e9e9'
                        },
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'landscape.man_made',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#d8d8d8'
                        },
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#efebe3'
                        },
                        {
                            visibility: 'simplified'
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#d8d8d8'
                        },
                        {
                            visibility: 'simplified'
                        },
                        {
                            weight: 1
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.text',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'poi.attraction',
                    stylers: [
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'poi.attraction',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            color: '#b3b6b9'
                        }
                    ]
                },
                {
                    featureType: 'poi.attraction',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#8c9296'
                        }
                    ]
                },
                {
                    featureType: 'poi.business',
                    stylers: [
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'poi.business',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            color: '#b3b6b9'
                        }
                    ]
                },
                {
                    featureType: 'poi.business',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#8c9296'
                        }
                    ]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#b7e4d1'
                        },
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff'
                        }
                    ]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#d9d9d9'
                        },
                        {
                            weight: 1.5
                        }
                    ]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#a9a9a9'
                        }
                    ]
                },
                {
                    featureType: 'road.local',
                    stylers: [
                        {
                            color: '#ffffff'
                        }
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#d8d8d8'
                        }
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#757575'
                        }
                    ]
                },
                {
                    featureType: 'water',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#b9d4f6'
                        }
                    ]
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#99a4ad'
                        }
                    ]
                }
            ],
            zoom: 11
        };

        this.settings = Object.assign({ }, settings, options);
        this.init = true;
        this.additionalDistrict = [];
        this.$mapWrapper = element;
        this.$map = this.$mapWrapper.querySelector('[data-map="map"]');
        this.initialize();
    }

    initialize () {
        if (this.init === true) {
            const ControlElement = (text) => {
                const uiControl = document.createElement('div');
                uiControl.classList.add('map-button', 'control-button');
                uiControl.title = text;

                return uiControl;
            };

            let zoom = this.settings.zoom;
            if (this.settings.breakpoints !== null) {
                if (window.outerWidth < this.settings.breakpoints.m) {
                    zoom = zoom - 1;
                }
            }

            this.map = new google.maps.Map(this.$map, { // eslint-disable-line
                styles: this.settings.styles,
                center: this.settings.position,
                mapTypeControl: this.settings.mapTypeControl,
                streetViewControl: this.settings.streetViewControl,
                disableDefaultUI: true,
                zoom: zoom
            });

            this.initZoomControl(this.map);
            this.initFullScreenControl();

            this.infoWindow = new google.maps.InfoWindow(); // eslint-disable-line

            if (this.settings.geolocationUi === true) {
                const geoControlDiv = document.createElement('div');
                const geoControl = new ControlElement('geolocation-button'); // eslint-disable-line

                geoControl.addEventListener('click', () => {
                    this.geoLocateMe();
                });

                geoControlDiv.appendChild(geoControl); // eslint-disable-line
                this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(geoControlDiv); // eslint-disable-line
            }

            if (this.settings.coordinates !== null) {
                const districtCoords = this.settings.coordinates;
                this.district = new google.maps.Polygon({ // eslint-disable-line
                    paths: districtCoords,
                    strokeColor: '#0A2737',
                    strokeOpacity: 1,
                    strokeWeight: 1,
                    fillColor: '#0A2737',
                    fillOpacity: 0.2
                });

                this.district.setMap(this.map);
            }

            if (this.settings.additionalCoordinates !== null) {
                for (const [key, coords] of this.settings.additionalCoordinates.entries()) {
                    this.additionalDistrict[key] = new google.maps.Polygon({ // eslint-disable-line
                        paths: coords,
                        strokeColor: '#0A2737',
                        strokeOpacity: 1,
                        strokeWeight: 1,
                        fillColor: '#0532FF',
                        fillOpacity: 0.2
                    });
                    this.additionalDistrict[key].setMap(this.map);
                }
            }
            this.init = false;
        }
    }

    initZoomControl (map) {
        this.$mapWrapper.querySelector('.zoom-control-in').onclick = function () {
            map.setZoom(map.getZoom() + 1);
        };

        this.$mapWrapper.querySelector('.zoom-control-out').onclick = function () {
            map.setZoom(map.getZoom() - 1);
        };

        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(this.$mapWrapper.querySelector('.zoom-control')); // eslint-disable-line
    }

    initFullScreenControl () {
        const elementToSendFullscreen = this.map.getDiv().firstChild;
        const fullScreenControl = this.$mapWrapper.querySelector('.fullscreen-control');

        fullScreenControl.addEventListener('click', (e) => {
            const map = this.$map;
            elementToSendFullscreen.requestFullscreen();
            if (map.classList.contains('is--fullscreen')) {
                this.exitFullscreen();
            } else {
                map.classList.add('is--fullscreen');
            }
            if (fullScreenControl.classList.contains('active--fullscreen')) {
                fullScreenControl.classList.remove('active--fullscreen');
            } else {
                fullScreenControl.classList.add('active--fullscreen');
            }
        });

        this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(this.$mapWrapper.querySelector('.fullscreen-control')); // eslint-disable-line
    }

    exitFullscreen () {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }

    geoLocateMe () {
        const handleLocationError = (browserHasGeolocation, infoWindow, pos) => {
            infoWindow.setPosition(pos);
            infoWindow.setContent(browserHasGeolocation ? google.maps.geolocation.errors.failed : google.maps.geolocation.errors.nosupport); // eslint-disable-line
            infoWindow.open(this.map);
        };

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const myPosition = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                this.infoWindow.setPosition(myPosition);
                this.infoWindow.setContent('My Position'); // eslint-disable-line
                this.infoWindow.open(this.map);
                this.map.setCenter(myPosition);
            }, () => {
                handleLocationError(true, this.infoWindow, this.map.getCenter());
            });
        } else {
            handleLocationError(false, this.infoWindow, this.map.getCenter());
        }
    }
}

export { Maps };
